import React, {Component} from "react";
import * as R from "ramda";
import FlexView from "react-flexview";
import {monthOptions, yearOptions} from "../config";
import {configMonthToDateCabang} from "./config";
import {removeNullFields} from "../../../../common/mapper";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";

class MonthToDateSalesReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            month: null,
            year: null,
            tableConfig: [],
            dataTable: [],
        };
    };

    componentDidMount() {
        let currentDate = new Date();
        this.setState((prevValue) => ({
            ...prevValue,
            // month: monthOptions.find(item => item.value === currentDate.getMonth()),
            month: monthOptions.find(
              (item) => item.value === currentDate.getMonth() + 1
            ),
            year: yearOptions.find(item => item.value === currentDate.getFullYear()),
            tableConfig: configMonthToDateCabang,
        }));
    };

    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     if (!R.equals(prevProps.search, this.props.search)) {
    //         this.handleSearch();
    //     }
    // };

    handleChangeSearchValue = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    transformResponseToTable = (data) => {
        return [
          ...data.data,
          {
            name: "Total",
            lastMonth: data.totalLastMonth,
            thisMonth: data.totalThisMonth,
            growth: data.growth,
            forecasting: data.totalForecasting,
          },
        ];
    }

    fetchData = async () => {
        try {
            let dataKodeCabang = this.props.search
            if (this.props.isAllSelected) {
              dataKodeCabang = this.props.dataCabang.map(
                (item) => item.kodeCabang
              );
            }
            const res = await fetchDataAsync({
              asyncFn:
                Api.create("NAGAMAS_REPORT_DTO").getLaporanJualanMTDSalesmanCS,
              setError: this.props.setError,
              menuName:
                "Dashboard Level Kacab - Laporan Jualan MTD Salesman CS",
              args: {
                kodeCabang: dataKodeCabang,
                year: this.state.year?.value,
                month: this.state.month?.value,
                mode: "CABANG",
                idLeader: this.props.idLeader,
              },
            });
            if(res.ok && res.data.status === HttpStatus.SUCCESS){
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataTable: this.transformResponseToTable(res.data.data),
                }));
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    handleSearch = () =>{
        this.fetchData();
    }

    render() {
        return (
            <>
                <FlexView style={{gap: "20px", alignItems: "center"}}>
                    <SimpleDDL
                        isClearable
                        id="select_options_month"
                        box="search"
                        name="month"
                        containerclassname="width width-250px"
                        placeholder="Bulan"
                        menuPosition="fixed"
                        options={monthOptions}
                        value={this.state.month}
                        onChange={(value, {name}) => this.handleChangeSearchValue(name, value)}
                    />
                    <SimpleDDL
                        isClearable
                        id="select_options_year"
                        box="search"
                        name="year"
                        containerclassname="width width-250px"
                        placeholder="Tahun"
                        menuPosition="fixed"
                        options={yearOptions}
                        value={this.state.year}
                        onChange={(value, {name}) => this.handleChangeSearchValue(name, value)}
                    />
                    <SimpleButton
                        styles={{marginBottom: "15px"}}
                        onClick={()=>this.handleSearch()}
                    >Cari</SimpleButton>
                </FlexView>
                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.state.tableConfig}
                    options={{
                      serverSide: false,
                      rowsPerPage: 50,
                      rowsPerPageOptions: [],
                    }}
                />
            </>
        );
    };
}

export default MonthToDateSalesReport;